import { styled } from '@mui/material';

export const SearchRefinementListItemStyled = styled('li')(() => ({ display: 'flex', alignItems: 'center' }));
